module.exports = __webpack_public_path__ + "static/media/ic_general_airplane_black.a6676f55.svg";